import React, { useCallback, useEffect, useState } from "react";
import hacker from "./hacker.png";
import "./Stand.css";
import _ from "lodash";
import Result from "./Result";
import Box from "./Box";
import {
  Button,
  Card,
  Divider,
  Image,
  Placeholder,
  Header,
  Icon,
  Modal,
} from "semantic-ui-react";
import "semantic-ui-css/semantic.min.css";
import "./Home.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import axios from "axios";
import { Link } from "react-router-dom";



const Stand = () => {
  const [result,setresult] = useState([
    {
      name: "test",
      email: "testing@mail.com",
      phone: "1111111",
      questions: [
        {
          optionOne: {
            statement: "dfdf",
            count: 0,
          },
          optionTwo: {
            statement: "aaaa",
            count: 0,
          },
          _id: "6592dc768de08b23b70cc46e",
          description: "dafdaskjfasl;jf",
          __v: 0,
        },
        {
          optionOne: {
            statement: "dfdf",
            count: 2,
          },
          optionTwo: {
            statement: "aaaa",
            count: 0,
          },
          _id: "6592dcd78de08b23b70cc479",
          description: "dafdaskjfasl;jf",
          __v: 0,
        }
      ],
    }
  ])
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    className: "slides",
  };
  const [canRequest,setrequest] = useState(true)
  const [canSend,setcansend] = useState([0])
  const [curremail,setemail] = useState(result[0].email);
  const [currinx,setinx] = useState(0);
  const [currchoice,setchoice] = useState([0]);
  const [currQuestion,setquestion] = useState(result[0].questions);
  const sendReq = () => {
      let updatedValue = currchoice.toString();
      console.log("updatedvalue:", updatedValue);
      fetch("https://plum-breakable-swordfish.cyclic.app/user/updatepoll",{
        method: "POST",
        credentials: 'include',
        body: JSON.stringify({
          choice:updatedValue,
          email:curremail
        }),
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(response => {
        return response.json();
      })
      .then(data => {
        console.log(data);
      })

      setcansend(canSend => {
        let newP = canSend;
        newP[currinx] = 0;
        return newP;
      })
      setinx(0);
      
  }

  const onld = () =>  {
    setrequest(false);
    fetch("https://plum-breakable-swordfish.cyclic.app/user/polls",{
      method: 'GET',
      credentials: 'include'
    })
    .then(response => {
      return response.json();
    })
    .then(data => {
      let newData = data.data;
      let len = data.data.len;
      let newarray = new Array(len).fill(1);
      setresult([...result,...newData]);
      setcansend([...canSend,...newarray]);
      console.log(result);
      console.log(canSend);
    })
    .catch(err => {
      console.error(err);
    })
  }

  

 

  return (
    <>
      <div className="all">
        <div id="stars"></div>
        <div id="stars2"></div>
        <div id="stars3"></div>
        <div id="title"></div>
        <div className="middle">
          <img src={hacker} alt="" className="hacker" />
        </div>
        <div className="left2">
          <div className="card2">
            <h2 className="heading2">Top Notch battle votes ......</h2>
            { canRequest===true?<button className="getReqbutton" onClick={onld}>Get Questions</button>:null}
            <div className="card3">
              {/* <p className="description">
                {result[0].questions[0].description}
              </p> */}
              {/* <button className="butn3">
                {result[0].questions[0].optionOne.statement}
              </button>
              <button className="butn3 butn4">
                {result[0].questions[0].optionTwo.statement}
              </button> */}
            </div>
                
            {result.map((item, index) => {
              return <Box key={index} email={item.email} name={item.name} phone={item.phone} questions={item.questions}
                setchoice={setchoice}
                setemail={setemail}
                setquestion={setquestion}
                currQuestion={currQuestion}
                currchoice={currchoice}
                curremail={curremail}
                currinx={currinx}
                setinx={setinx}
                inx={index}
              />;
            })}
            {/* <Result
              countone={result[0].questions[0].optionOne.count}
              counttwo={result[0].questions[0].optionTwo.count}
              optionOne={result[0].questions[0].optionOne.statement}
              optiontwo={result[0].questions[0].optionTwo.statement}
            /> */}
          </div>
        </div>
        <div className="rightQ">
        
          {
            currQuestion.map((item,index) => {
              return <Result
              key={index}
              inx={index}
              description={item.description}
              countone={item.optionOne.count}
              counttwo={item.optionTwo.count}
              optionOne={item.optionOne.statement}
              optiontwo={item.optionTwo.statement}
              setchoice={setchoice}
              currchoice={currchoice}
              
            />
            })
          }
          {canSend[currinx]!==0?<button className="getReqbutton" style={{width:'150px'}} onClick={sendReq}>submit</button>:null}
        </div>
      </div>

    </>
  );
};

export default Stand;
